import styled, { css } from 'styled-components';

export const CardContainer = styled.div<{ $backgroundColor: string, $isERC20: boolean }>`
  position: relative;
  width: 278px;
  min-height: 311px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border-radius: 16px;
  background: ${props => props.$isERC20 ? 'transparent' : props.$backgroundColor};
  box-shadow: ${props => props.$isERC20 ? 'none' : '-4px 4px 4px 0px rgba(10, 20, 26, 0.30)'};
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-4px);
  }

  ${props => props.$isERC20 && css`
    & .title {
      color: red;
      text-align: center;
      display: none;
    }
  `}
`;

export const CardImage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: 234px;
    border-radius: 16px;
    display: block;
    object-fit: cover;
  }
`;

export const CardTitle = styled.div`
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-family: 'Red Hat Display', sans-serif;
  font-feature-settings: 'liga' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  text-align: left;
`;

export const FloatText = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const IconNumber = styled.div`
  color: ${({ theme }) => theme?.colors?.text?.headings};
  display: flex;
  align-self: center;
  justify-content: center;
  border-radius: 32px;
  background: ${({ theme }) => theme?.colors?.theme?.contentBg};
  padding: 8px 16px;
  font-size: 16px;
  width: fit-content;
  gap: 8px;
  margin-bottom: 16px;
`;
